import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import { Button, TextField } from "@material-ui/core";

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export default function ChipsArray({ tags }) {
  const [val, setVal] = useState(["MERN" , "CSS" , "Dedicated"]);
  const [input , setInput] = useState('');
  const [filtered ,setFiltered] = useState([])

  const handleDelete = (chipToDelete) => () => {
    setVal((chips) => val.filter((chip) => chip !== chipToDelete));
  };

  const handleInputs = (e) => {
    setInput(e.target.value);
    setVal(e.target.value);
    fetchSkills(input);

  };

  const fetchSkills = (val) => {
    // console.log(e.target.value);
    setFiltered(tags.filter((skill) => skill.match(val)));
    console.log(filtered)
    // setVal(filtered);

  };

  return (
    <>
      <TextField
        label="Requirements"
        name="requirements"
        value={input}
        onChange={handleInputs}
        InputLabelProps={{ className: "textfield__label" }}
        TextField={{ className: "textfield__border" }}
      />

      <div className="filtered">{
          filtered.map((i => (
              <div>{i}</div>
          )))
      }</div>

      {val.map((skill) => (
        // <ListItem key={skill}>
        <Chip label={skill} onDelete={handleDelete(skill)} className="chips" />
        // </ListItem>
      ))}
    </>
  );
}
